import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const t = localStorage.getItem("ma_token");
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch { setUser(null); }
    setLoading(false);
  };

  useEffect(() => { loadMe(); }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ma_token", r.data.access_token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ma_token");
    setUser(null);
  };

  const has = (perm) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    return (user.permissions || []).includes(perm);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh: loadMe, has }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
